//External
import React, { useState, useEffect } from "react";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  LinkedinIcon,
  PinterestIcon,
} from "react-share";

import Button from "react-bootstrap/Button";
//Internal
import SocialShareModel from "./socialShareModel";

/*******************
@Purpose : used for social medial share
@Parameter : { Data }
@Author : INIC
******************/
function SocialShare({ data }) {
  const [active, setActive] = useState();
  const [url, setUrl] = useState();

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  /*******************
  @Purpose : React Hook used for href path
  @Parameter : {}
  @Author : INIC
  ******************/
  useEffect(() => {
    const host = window.location.href;
    setUrl(host);
  }, []);

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      <div className={active ? "blog-sharing active" : "blog-sharing"}>
        <FacebookShareButton url={url} title={"FaceBook"}>
          <FacebookIcon size={40} />
        </FacebookShareButton>
        <br />
        <TwitterShareButton title={"Twitter"} url={url}>
          <TwitterIcon size={40} />
        </TwitterShareButton>
        <br />
        <LinkedinShareButton title={"LinkedIn"} url={url}>
          <LinkedinIcon size={40} />
        </LinkedinShareButton>
        <br />
        <PinterestShareButton
          url={url}
          title={"Pinterest"}
          media={data?.featured_image}
        >
          <PinterestIcon size={40} />
        </PinterestShareButton>
        <br />
        <WhatsappShareButton url={url}>
          <WhatsappIcon size={40} />
        </WhatsappShareButton>
        <br />
        <Button
          variant="warning"
          className="d-inline-block share-more p-0 d-flex justify-content-center align-items-center rounded-0"
        >
          <div onClick={handleShow}>
            <span className="icon icon-sharing"></span>
            <span className="text-decoration-underline share-text">Share</span>
          </div>
        </Button>
        <span
          className="icon icon-right-inside d-none d-md-inline-block"
          onClick={() => setActive(!active)}
        ></span>
      </div>
      <SocialShareModel
        data={data}
        iconClass="icon icon-sharing"
        show={show}
        handleClose={handleClose}
        flag="blog"
      />
    </>
  );
}

export default SocialShare;
